import { Divider } from '@mui/material';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';
import { Customization } from 'types/Customization';
import { CustomColor } from './CustomColor';
import CustomColorPicker from './CustomColorPicker';

export const ContactFormThemeSection = () => {
    const { customization, setCustomization } = useSearchAiPluginStore();
    return (
        <div className="w-8/12 p-6">
            <h1 className="text-xl font-bold text-gray-800 mb-2">Connect Your Way</h1>
            <p className="text-gray-600 mb-8 text-base leading-7">
                Create a customized contact form that encourages visitors to reach out and
                <br /> makes it easy to gather the information you need.
            </p>
            <DividerSection />

            <FormSection title="Form title" description="Welcome visitors with a friendly and inviting form title.">
                <FormInput
                    placeholder="Get in touch about this listing..."
                    value={customization.formTitle}
                    setCustomization={setCustomization}
                    field="formTitle"
                    maxValue={40}
                />
            </FormSection>

            <DividerSection />

            <FormSection
                title="Provide Additional Content"
                description="Use the form subtext to give visitors more information or instructions about filling out the form.."
            >
                <FormInput
                    placeholder="Your information will be solely used to respond to your inquiry..."
                    value={customization.formDescription}
                    setCustomization={setCustomization}
                    field="formDescription"
                    maxValue={70}
                />
            </FormSection>

            <DividerSection />

            <div className="my-8">
                <h2 className="text-lg font-bold text-gray-800 mb-2">Form Theme</h2>
                <p className="text-gray-600 mb-4 text-base leading-7">
                    Choose a form theme that complements your website's design and reinforces your brand <br />
                    identity.
                </p>
                <CustomColorPicker colorField="themeColor" />
                <CustomColor colorField="themeColor" />
            </div>
        </div>
    );
};

interface FormSectionProps {
    title: string;
    description: string;
    children?: React.ReactNode;
}

const FormSection = ({ title, description, children }: FormSectionProps) => (
    <div className="my-8">
        <h2 className="text-lg font-bold text-gray-800 mb-2">{title}</h2>
        <p className="text-gray-600 mb-3">{description}</p>
        {children}
    </div>
);
interface FormInputProps {
    placeholder: string;
    value: string;
    setCustomization: (field: keyof Customization, value: string) => void;
    field: keyof Customization;
    maxValue: number;
}

const FormInput = ({ placeholder, value, setCustomization, field, maxValue }: FormInputProps) => (
    <div className="relative">
        <input
            type="text"
            placeholder={placeholder}
            className="w-full px-4 py-3.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={value}
            maxLength={maxValue}
            onChange={(e) => setCustomization(field, e.target.value)}
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">
            {value.length}/{maxValue}
        </span>
    </div>
);

const DividerSection = () => (
    <>
        <div className="my-10"></div>
        <Divider />
    </>
);
